























import { SfRadio } from '@storefront-ui/vue';
import { ref, onMounted, defineComponent } from '@nuxtjs/composition-api';
import usePaymentProvider from '~/modules/checkout/composables/usePaymentProvider';
import type { AvailablePaymentMethod } from '~/modules/GraphQL/types';
import { Stripe } from '@headlesscommerce/vsf-magento-stripe';

export default defineComponent({
  name: 'VsfPaymentProvider',
  components: {
    SfRadio,
    Stripe
  },
  emits: ['status'],
  setup(_props, { emit }) {
    const paymentMethods = ref<AvailablePaymentMethod[]>([]);
    const { load, save } = usePaymentProvider();
    const selectedPaymentMethodCode = ref<string | null>(null);
    const StripeRef = ref(null);

    onMounted(async () => {
      paymentMethods.value = await load();
    });

    const definePaymentMethods = async (paymentMethodCode: string) => {
      paymentMethods.value = await save({
        paymentMethod: {
          code: paymentMethodCode,
        },
      });

      selectedPaymentMethodCode.value = paymentMethodCode;

      if (paymentMethodCode !== 'stripe_payments') {
        emit('status', paymentMethodCode);
      }
    };

    // Validate and initiate stripe setPaymentMethod function
    const triggerStripe = () => {
      if (selectedPaymentMethodCode.value == 'stripe_payments') {
        return StripeRef.value[0].setPaymentMethod();
      } else {
        return;
      }
    }
    const paymentStatus = () => {
      emit('status', 'true');
    };

    return {
      paymentMethods,
      paymentStatus,
      triggerStripe,
      selectedPaymentMethodCode,
      definePaymentMethods,
      StripeRef
    };
  },
});
